import { render, staticRenderFns } from "./storeDecorationTemplateConfig.vue?vue&type=template&id=c7730c40&scoped=true&"
import script from "./storeDecorationTemplateConfig.vue?vue&type=script&lang=js&"
export * from "./storeDecorationTemplateConfig.vue?vue&type=script&lang=js&"
import style0 from "./storeDecorationTemplateConfig.vue?vue&type=style&index=0&id=c7730c40&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7730c40",
  null
  
)

export default component.exports